import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseFormV2Step1Layout, BaseFormV2Step1LayoutProps } from "./BaseFormV2Step1Layout";

import { useMediaQuery } from "@/hooks/useMediaQuery";

export type PeerToPeerFormV2PrimaryCampaignStep1LayoutProps = Omit<BaseFormV2Step1LayoutProps, "slots"> & {
  slots: {
    banner?: React.ReactNode;
    organizationLogo: React.ReactNode;
    summary: React.ReactNode;
    donors?: React.ReactNode;
    fundraisers?: React.ReactNode;
    donateOrFundraiseOptions: React.ReactNode;
  };
};

export const PeerToPeerFormV2PrimaryCampaignStep1Layout: FC<PeerToPeerFormV2PrimaryCampaignStep1LayoutProps> = ({
  slots,
  isOneColumn,
  isEmbed,
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseFormV2Step1Layout
      {...rest}
      isOneColumn={isOneColumn}
      isEmbed={isEmbed}
      slots={{
        banner: slots.banner,
        info: (
          <Stack alignItems="flex-start" width="100%" gap={2}>
            {!isSmallScreen && slots.organizationLogo}
            {slots.summary}
            {!isSmallScreen && !isOneColumn && !isEmbed && slots.donors}
          </Stack>
        ),
        order: (
          <Stack width="100%" gap={5}>
            {slots.donateOrFundraiseOptions}
            {(slots.fundraisers || ((isSmallScreen || isOneColumn || isEmbed) && slots.donors)) && (
              <Stack width="100%" gap={2}>
                {slots.fundraisers}
                {(isSmallScreen || isOneColumn || isEmbed) && slots.donors}
              </Stack>
            )}
          </Stack>
        ),
      }}
    />
  );
};
